<template>
    <div style="min-height: 85vh">
        <products/>
        <services/>
    </div>
</template>

<script>
    import Products from "../components/productservices/products";
    import Services from "../components/productservices/services";
    export default {
        name: "ProductsServices",
        components: {Services, Products}
    }
</script>

<style scoped>

</style>